import React from 'react';
import AsyncSelect from 'react-select/lib/Async';

const InputAsync = (props) => {
  const { error, help } = props;

  return (
    <div className={`col-md-${props.col} col-sm-12`} style={{ display: 'flex' }}>
      <div className="input-type-style" style={{ display: 'flex' }}>
        <AsyncSelect
          isClearable
          placeholder="Buscar..."
          loadingMessage={() => 'Carregando...'}
          noOptionsMessage={() => 'Nenhum resultado encontrado'}
          cacheOptions={false}
          {...props}
        />
        {error && error.map(e => <label key={e} className="input-helper text-danger">{e}</label>)}
        {error && help && <br />}
        {help && <span className="input-helper">{help}</span>}
      </div>
    </div>
  );
};

export default InputAsync;
